import "./style.css";

export default function CarouselArrow({
  direction = "next",
  className = "",
  ariaLabel,
  ...buttonProps
}) {
  const directionClass =
    direction === "prev" ? "carousel-arrow--prev" : "carousel-arrow--next";

  return (
    <button
      type="button"
      className={`carousel-arrow ${directionClass} ${className}`.trim()}
      aria-label={ariaLabel}
      {...buttonProps}
    >
      <svg viewBox="0 0 48 75" fill="none" aria-hidden="true">
        <path
          d="M10.6055 63.6064L37.3516 37.826L10.6055 10.6064"
          stroke="currentColor"
          strokeWidth="15"
          strokeLinecap="square"
        />
      </svg>
    </button>
  );
}
